export default __webpack_public_path__ + "static/media/account-check.c7c5483d.svg";